<template>
  <div
    :id="`${name}-panel`"
    class="panel h-100"
    :class="panelClass"
  >
    <div
      class="h-100 d-flex flex-column justify-content-start align-items-stretch"
    >
      <div
        :id="`${name}-panel-header`"
      >
        <slot name="panel-header" />
      </div>

      <div
        :id="`${name}-panel-content`"
        class="h-100 position-relative"
        :class="[{ 'content-class': collapses, 'border bg-sachlich-white': !hasSpacing }, panelContentClass]"
        @scroll="onScroll"
      >
        <slot name="panel-content" />
      </div>

      <div 
        :id="`${name}-panel-footer`"
        class="bg-sachlich-white border"
        :class="hasSpacing ? 'mt-2' : 'border-top-0'"
      >
        <slot name="panel-footer" />
      </div>
    </div>
    <slot name="panel-overlay" />
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue';

export default {
  props: {
    name: { type: String, default: '' },
    title: { type: String, default: undefined },
    footer: { type: Boolean, default: false },
    collapses: { type: String as PropType<'left' | 'right'>, default: null },
    collapsed: { type: Boolean, default: false },
    tabs: { type: Array, default: null },
    activeTabIndex: { type: Number, default: -1 },
    onScroll: { 
      type: Function as PropType<(payload: Event) => void>, 
      default: undefined },
    hasSpacing: { type: Boolean, default: false },
    panelContentClass: { type: String, default: '' }
  },

  computed: {
    panelClass() {
      if (this.collapses === 'left' && this.collapsed) {
        return 'collapses-left-collapsed'
      }

      if (this.collapses === 'left' && !this.collapsed) {
        return 'collapses-left'
      }

      if (this.collapses === 'right' && this.collapsed) {
          return 'collapses-right-collapsed'
        } 

      if (this.collapses === 'right' && !this.collapsed) {
        return 'collapses-right'
      }

      else {
        return 'no-collapsing'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.panel {
  font-size: $default-font-size;
  transition: margin 0.4s ease-out;
}

.border {
  border: 1px solid $color-aida-border;
}

.content-class {
  overflow-x: hidden; 
  overflow-y: auto;
}

.collapses-left {
  margin-left: 6px
}

.collapses-left-collapsed {
  margin-left: -275px
}

.collapses-right,
.collapses-right-collapsed {
  width: 640px;
}

.collapses-right {
  margin-right: 6px
}

.collapses-right-collapsed {
  margin-right: -640px
}

.no-collapsing {
  flex: 1; 
  margin-left: 6px; 
  margin-right: 6px; 
  overflow: hidden;
}
</style>
